import { loadScript } from "@videojs/utils/dom";
//#region src/stream-api.ts
const API_URL = "https://embed.videodelivery.net/embed/sdk.latest.js";
/** Load the Stream SDK once, reusing it if another host already pulled it in. */
async function loadCloudflareStreamApi() {
	const existing = globalThis.Stream;
	if (existing) return existing;
	await loadScript(API_URL);
	const api = globalThis.Stream;
	if (!api) throw new Error("Cloudflare Stream SDK failed to load");
	return api;
}
//#endregion
export { loadCloudflareStreamApi };
